import React from 'react';
import Image from './image';
import './footer.css';

export default function Footer({ prepend = '' }) {
  return (
    <div className="footer">
      <h3>Site Map</h3>
      <ul>
        <li>
          <a href={`${prepend}index.html`}>Home</a>
        </li>
        <li>
          <a href={`${prepend}pmp.html`}>Smart Panelboard</a>
        </li>
        <li>
          <a href={`${prepend}bcp_commercial.html`}>Lighting Control Panel</a>
        </li>
        <li>
          <a href={`${prepend}retrofits.html`}>Retrofits</a>
        </li>
        <li>
          <a href={`${prepend}pms.html`}>Smart Switchboard</a>
        </li>
        <li>
          <a href={`${prepend}bcp_theater.html`}>Breaker Control Panel</a>
        </li>
        <li>
          <a href={`${prepend}touring.html`}>Smart Distro Touring Panel</a>
        </li>
        <li>
          <a href={`${prepend}rdm.html`}>RDM Conformance Tester</a>
        </li>
        <li>
          <a href={`${prepend}bsc.html`}>Smart Contactor</a>
        </li>
        <li>
          <a href={`${prepend}horticulture/`}>Horticulture</a>
        </li>
        <li>
          <a href={`${prepend}downloads.html`}>Downloads</a>
        </li>
        <li>
          <a href={`${prepend}contact.html`}>Contact</a>
        </li>
      </ul>
      <Image
        src={`logo-bsp.png`}
        alt="logo of B with lightning bolt"
        height="35px"
      />
      <span>©Copyright MMVIII W.A. Benjamin Electric All Rights Reserved</span>
    </div>
  );
}
